<template>
  <header>
  	<!--<div class="alert alert-warning">
  		您还没有完善供应商信息，所提交的供货信息仅当前浏览器可见。为了便于经销商确认报价并与您取得联系，建议尽快<a href="javascript:;">完善注册信息</a>！
  	</div>-->
    <h1>
    	<router-link :to="{ path: '/' }"></router-link>
    </h1>
    <div v-if="type==1">
      <input type="text" id="searchInputS" placeholder="搜索商品名称，多个关键词用空格分开" @keyup.enter="search">
      <button type="button" @click="search">搜索</button>
    </div>
    <div v-if="type==1 || type==2 || type==4" class="check-box">
    	<a href="javascript:;" @click="openRegModal()">我的历史报价信息</a>
    	<!--<router-link :to="{ path: 'page-offer-his' }">我的历史报价信息</router-link>-->
    </div> 
  </header>
</template>

<script>
export default {
	props:["type"],
  methods: {
    search() {
    	this.$emit("search", document.getElementById("searchInputS").value);
    },
    openRegModal(type){
    	this.$emit("openRegModal",this.type);
    }
  }
};
</script>
<style lang="less" scoped>
@import "./../assets/style/config.less";
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #fff;
  border-bottom: 0.0625rem #e6e6e6 solid;
  min-width: 39.375rem;
}
header h1 {
  display: none;
  margin: 0 1rem 0 0;
  width: 140px;
  height: 45px;
  background-image: url('./../assets/img/logo2.png');
  background-size: 100% 100%;
  position: relative;
}
header h1 a{
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: transparent;
}
header > div {
  display: flex;
  align-items: stretch;
}
input[type="text"] {
  width: 20rem;
  height: 2rem;
  padding: 0 0.375rem;
  border: 0.0625rem #c1c1c1 solid;
  border-right: none;
}
input[type="text"]:focus {
  border-color: @primary;
}
button {
  padding: 0 1rem;
  background-color: @primary;
  border: none;
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
}
.check-box {
  margin-left: 1rem;
  font-size: 0.875rem;
  user-select: none;
}
.check-box a{
	color: @primary;
	font-weight: 700;
}
.check-box h1{
	font-size: 16px;
}
.alert {
    position: relative;
    border-width: 0px;
    padding: 15px 20px;
}
.alert-warning {
    color: rgb(196, 119, 9);
    background-color: rgb(252, 230, 198);
    border-color: rgb(244, 153, 23);
}
.alert a{
	color: rgb(196, 119, 9);
	text-decoration: underline;
	font-weight: 700;
}
@media (min-width: 700px) {
  header h1 {
    display: block;
  }
}
</style>

